import { date, number, object, string } from "yup";
import { DOSE_MgKg } from "duck";
import { RouteEnum } from "requests";

export const getValidation = (isNonEmergencyMedication: boolean) => {
  const nullableNumber = number()
    .required()
    .nullable()
    .transform(value => (Number.isNaN(value) ? 0 : value));

  const validationSchema = object().shape({
    name: string()
      .default(null)
      .required()
      .nullable(),
    dose: nullableNumber,
    doseUnit: string()
      .required()
      .default(DOSE_MgKg)
      .nullable(),
    concentration: nullableNumber,
    route: string()
      .required("Route can’t be blank.")
      .nullable()
      .default(isNonEmergencyMedication ? "" : RouteEnum.Iv),
    timeAdministered: date()
      .nullable()
      .default(null),
    volumeAdministered: number()
      .nullable()
      .transform(value => (Number.isNaN(value) ? 0 : value)),
    additionalVolumeAdministered: number()
      .nullable()
      .transform(value => (Number.isNaN(value) ? 0 : value)),
    additionalVolumeDrawn: number()
      .nullable()
      .transform(value => (Number.isNaN(value) ? 0 : value)),
    initials: string()
      .nullable()
      .default("")
  });

  return {
    validationSchema,
    defaultValues: validationSchema.cast({})
  };
};
